import React from "react";
import { retailGidGroups } from "../../config";
import "./Header.css";

const Header = ({ claims }) => {
  const hasRetailGidGroup =
    claims &&
    claims.groups &&
    claims.groups.some((groups) =>
      retailGidGroups.includes(groups)
    );

  console.log("Header.js: claims", claims);

  return (
    <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-black justify-content-between">
      <div className="navbar-brand ncss-brand u-uppercase">
        <span className="text-color-white display-3">
          <i className="g72-swoosh"></i> ServiceDesk-Assisted Password Reset
        </span>
      </div>
      <div className="navbar-nav">
        {hasRetailGidGroup && (
          <div className="nav-item">
            <a
              className="nav-link text-color-white"
              href="/RetailGIDManagement"
            >
              Manage Retail GIDs
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
